import React, { useState } from 'react';
import '../styles/Life.css';

const lifeItems = [
  {
    image: 'award.jpeg',
    date: 'June 24, 2025',
    title: 'Green Factory Award',
  },
  {
    image: 'sales.jpeg',
    date: 'June 29, 2025',
    title: 'Annual Sales Conference',
  },
  {
    image: 'fair.jpeg',
    date: 'June 20, 2025',
    title: 'Bdjobs Technical Job Fair',
  },
];

const ITEMS_TO_DISPLAY = 3;

function Life() {
  const [startIndex, setStartIndex] = useState(0);

  const nextSlide = () => {
    setStartIndex((prevIndex) =>
      prevIndex + 1 >= lifeItems.length ? 0 : prevIndex + 1
    );
  };

  const prevSlide = () => {
    setStartIndex((prevIndex) =>
      prevIndex === 0 ? lifeItems.length - 1 : prevIndex - 1
    );
  };

  // Removed useEffect with auto sliding here

  const getVisibleItems = () => {
    const items = [];
    for (let i = 0; i < ITEMS_TO_DISPLAY; i++) {
      const index = (startIndex + i) % lifeItems.length;
      items.push(lifeItems[index]);
    }
    return items;
  };

  return (
    <section className="life-section" id="events">
      <div className="life-header">
        <h2 className="life-title">OUR EVENTS</h2>
        <div className="life-nav-buttons">
          <button onClick={prevSlide} className="life-nav-btn">&larr;</button>
          <button onClick={nextSlide} className="life-nav-btn">&rarr;</button>
        </div>
      </div>

      <div className="life-grid">
        {getVisibleItems().map((item, idx) => (
          <div className="life-card" key={idx}>
            <img
              src={require(`../Assets/Images/${item.image}`)}
              alt={item.title}
              className="life-image"
            />
            <p className="life-date">{item.date}</p>
            <h3 className="life-card-title">{item.title}</h3>
          </div>
        ))}
      </div>

      
    </section>
  );
}

export default Life;
